
import {transformExtent, transform} from "ol/proj";
import {getWmsInfo} from "@/http/services/http-services-wms";
import {createGeoJsonLayer, getDefaultName} from "@/helpers/geo-json-helper";
import {getGeometryByLayerName, removeLayer} from "@/helpers/ol-layer-helper";
import {setInfoValue} from "@/helpers/info-overview-helper";
import {getFileUploads} from "@/helpers/file-upload-helper";
import {WKT} from "ol/format";
import {Point} from "ol/geom";
import {generateCanvas} from "@/helpers/canvas-helper";

export function displayFeatureInfo(pixel,coordinate) {
    const destinationProjection = 'EPSG:28992'

    const result = transform([ coordinate[0], coordinate[1] ], 'EPSG:3857', destinationProjection)
    const size = window.map.getSize()
    const extend = new transformExtent(window.map.getView().calculateExtent(map.getSize()), "EPSG:3857", destinationProjection)

    const wmsGetFeatureInfo = {}
    wmsGetFeatureInfo.width = size[0]
    wmsGetFeatureInfo.height = size[1]

    wmsGetFeatureInfo.I = Math.round(pixel[0])
    wmsGetFeatureInfo.J = Math.round(pixel[1])

    wmsGetFeatureInfo.x = result[0]
    wmsGetFeatureInfo.y = result[1]

    if(destinationProjection === 'EPSG:4326') {
        wmsGetFeatureInfo.extent = extend[1] + ',' + extend[0] + ',' + extend[3] + ',' + extend[2]
    } else {
        wmsGetFeatureInfo.extent = extend.join(',')
    }
    wmsGetFeatureInfo.isMobile = "1"

    wmsGetFeatureInfo.info_objects =[]

    wmsGetFeatureInfo.info_objects .push({
        layerid: 1069
    })

    getWmsInfo('', wmsGetFeatureInfo).then((response) => {
        return response.json()
    }).then((result) => {

        removeLayer('selectedFeature')
        const features = result.mainTabs[0].features
        let innerHtml = 'Geen boom gevonden'
        let selectedItem = `
            <div class="alert alert-secondary alert-dismissible fade show">
            <span class="fa fa-circle"></span> Kies een object in de kaart
          </div>`

        if(features.length > 0) {
            createGeoJsonLayer(features[0].feature)

            innerHtml = ''

            const featureInfo = features[0].featureInfo.find(featureInfo => featureInfo.keyColumn !== undefined)
            const name = featureInfo.keyColumn
            const value = featureInfo.keyColumnValue
            let linkedValue = ''

            features[0].featureInfo[0].records[0].attributes.map((attribute, key) => {

                attribute.map(attributeItem => {
                    if(key === 0) {
                        generateCanvas()
                    }

                    innerHtml += '<div class="row">'
                    innerHtml += '<div class="col-5">' + attributeItem.DisplayName + '</div>'
                    innerHtml += '<div class="col-7">' + attributeItem.Value + '</div>'
                    innerHtml += '</div>'

                    if(attributeItem.Attribute === value) {
                        linkedValue = attributeItem.Value
                    }
                })
            })

            document.querySelectorAll('form-element').forEach(formElement => {
                window.wizard.Items.map( wizardItem => {
                    const item = wizardItem.Items.find( item => item.Attribute === name)
                    if (item !== undefined && parseInt(formElement.dataset.id) === item.AttributeID) {
                        const input = formElement.querySelector('input')
                        if(input !== null) {
                            input.value = linkedValue
                        }
                    }
                })
            })

            let isNotified = false
            const featureLinked = features[0].featureInfo.find(feature => feature.keyColumn !== undefined)
            if(featureLinked) {
                if(featureLinked.records.length > 0) {
                    isNotified = true
                }
            }

            if(isNotified) {
                selectedItem = `
                <div class="alert alert-warning alert-dismissible fade show">
                    <span class="fa fa-check"></span> Er is al een melding gedaan, we zijn op de hoogte. Wilt u toch een extra melding, klik dan op Volgende
                </div>`
            } else {
                selectedItem = `
                <div class="alert alert-success alert-dismissible fade show">
                    <span class="fa fa-check"></span> U heeft een object gekozen
                </div>`
            }
        }

        document.getElementById('selectedItem').innerHTML = selectedItem
    })
}
